import { Component, OnInit } from '@angular/core'
import { year, slakpidatabase } from './../../../models/slakpi';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { UserService } from './../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  GridOption,
  FileType
} from 'angular-slickgrid';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-kpi-follow-up',
  templateUrl: './kpi-follow-up.component.html',
  styleUrls: ['./kpi-follow-up.component.css']
})
export class KPIFollowUpComponent implements OnInit {

  columnDefinitions: Column[];
  gridOptions: GridOption; 
  public loading: boolean = true;
  public isPageLoad: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;

  public slakpiFollowUp_data: any;
  public yearData: any;
  public quaterData: any;
  public frequency_data: any;

  public yearUno?: number;
  public quarterUno?: number;
  public frequencyUno?: number;
  public Qyearsla: number = 0;
  public Qquatersla: number = 0;

  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;


  columnCommentDefinitions: Column[];
  searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
  isDigitalDewa: boolean = false;
   

  constructor(public restApi: SLAKPIApiService, private userService: UserService, public utilityService: UtilityService, private activatedRoute: ActivatedRoute) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;

  }
  ngOnInit() {
    this.activatedRoute.queryParams
      .subscribe(params => {
        
        if (params.isscheduler == 1) {
          let inpValue = new year();
          inpValue.languageUno = 1033;
          inpValue.itemUno = 0;
          inpValue.condition = 1;
          inpValue.tenantUno = this.tenantUno;
          inpValue.userUno = this.login_UserID;
          this.restApi.GetTrnKPIFollowUp(inpValue)
            .subscribe(data => {
            })
        }
      }
      );
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
    };

    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;

    //Get Default Vlaues
    this.loadFilterValues();
    this.loadFrequency();
  }

  //Load Filter FollowUp Values
  loadFilterValues() {
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
       
        let objdata: any = data;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
          this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
          this.loadSlaKpiFollowUp(); //by filter

        }, 30);


      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }



  loadFrequency() {
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }



  // Get slakpi FollowUp list
  loadSlaKpiFollowUp() {
    this.loading = true;
    let inpValue = new slakpidatabase();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    let userRole = (this.user.role == 'Administrator') ? 3 : 4;
    inpValue.condition = userRole;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.kpiyear = this.yearUno ? this.yearUno : 0;
    inpValue.kpiquarter = this.quarterUno ? this.quarterUno : 0;
    inpValue.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;
    inpValue.half = this.currentHalf;
    inpValue.month = this.currentMonth;
    this.restApi.getSlaKpiFollowUp(inpValue)
      .subscribe(data => {
     
        this.slakpiFollowUp_data = data;
        this.dataset = data;
        this.dataSearch = data;
        if (this.dataset.length > 0) {
          this.setColnDefn();
        }

        this.loading = false;
        this.isPageLoad = false;
      },
        (error) => {
          //Called when error

          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  uniqueArray(arrayList, val, label) {

    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }

    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiName && a.kpiName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.divisionName && a.divisionName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.period && a.period.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.type && a.type.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetValueText && a.targetValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.actualValueText && a.actualValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.currentStage && a.currentStage.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiName', name: 'KPI', field: 'kpiName', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'divisionName', name: 'Division', field: 'divisionName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionName', 'divisionName'),
          model: Filters.multipleSelect,
        },

      },
      {
        id: 'period', name: 'Period', field: 'period', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'period', 'period'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'type', name: 'KPI Type', field: 'type', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'type', 'type'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'actualValueText', name: 'Actual', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'actualValueText', 'actualValueText'),
          model: Filters.multipleSelect,
        },

      },
      {
        id: 'targetValueText', name: 'Target', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true,

        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValueText', 'targetValueText'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'currentStage', name: 'Status', field: 'currentStage', type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno == 0)
            return '<span  class="status-area status-red">Data Entry</span>';
          else if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-orange">Approval 1</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-yellow">Approval 2</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-light-green">Approval 3</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 1 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-green">Completed</span>';
        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'currentStage', 'currentStage'),
          model: Filters.multipleSelect,
        }
      },

     
    ]


  }

  // Choose city using select dropdown

  onchangeYear(e) {
   
    this.yearUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0;
    this.onSelectedTab();
  }

  onchangeQuarter(e) {
    this.quarterUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0;
    this.onSelectedTab();
  }

  onchangeFrequency(e) {
    this.frequencyUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0;
    this.onSelectedTab();
  }

  onSelectedTab() {
    if (!this.isPageLoad)
      this.loadSlaKpiFollowUp(); //by filter
  }


}
